import {
    ApolloClient,
    createHttpLink,
    InMemoryCache,
} from '@apollo/client/core'
import { onError } from "apollo-link-error";
import { ApolloLink } from 'apollo-link';
import { createApolloProvider } from '@vue/apollo-option'

// HTTP connection to the API
const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: import.meta.env.VITE_API_URL + '/sidesinv',
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
    },
    credentials: "include",
})

//Sets a global error handler using the Apollo Error Link
const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
        graphQLErrors.forEach(({ message, extensions }) => {
            if (extensions && extensions.category === 'authentication') {
                // Redirect to login if authentication error occurs
                window.location.href = import.meta.env.VITE_API_URL + '/login';
            } else {
                console.error(`[GraphQL error]: Message: ${message}`);
            }
        });
    }

    if (networkError) {
        console.error(`[Network error]: ${networkError}`);
        
        // Handling 401 Unauthorized error specifically
        if (networkError.statusCode === 401) {
            console.error('Unauthorized - Redirecting to login');
            window.location.href = import.meta.env.VITE_API_URL + '/login';
        }
    }
})

//Combines the Apollo Http and Error links
const link = ApolloLink.from([
    errorLink,
    httpLink,
]);

const defaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  }

// Cache implementation
const cache = new InMemoryCache()

// Create the apollo client
const apolloClient = new ApolloClient({
    cache,
    link,
    devtools: { enabled: import.meta.env.DEV },
    defaultOptions,
    queryDeduplication: false
})


export const apolloProvider = createApolloProvider({
    defaultClient: apolloClient,
})